import DynamicIcon from "./DynamicIcon";

export default function CustomSelectElement({
    id,
    name,
    list,
    setter,
    defaultValue,
    labelKey = "label", // Valore predefinito
    valueKey = "value" // Valore predefinito
}) {
    // Gestore dell'evento change
    const handleChange = (e) => {
        // Verifico che la lista esista prima di procedere
        if (!list || list.length === 0) {
            console.warn('CustomSelectElement: list is undefined or empty');
            return;
        }
        
        // Ottiengo il valore selezionato
        const value = e.target.value;
        // Trovo l'oggetto corrispondente al valore selezionato
        const selectedItem = list.find(item =>
            String(item[valueKey]) === value || String(item[labelKey]) === value
        );
        if (selectedItem) {
            // Passo sia il valore che l'etichetta
            setter(String(selectedItem[valueKey]), String(selectedItem[labelKey]));
        }
    };
    return (
        <div className="border border-slate-400 flex items-center gap-2 p-2 rounded-lg w-fit">
            <select
                name={name}
                id={id}
                onChange={handleChange}
                className="text-slate-500"
                value={defaultValue !== undefined && defaultValue !== null ? defaultValue : (list && list.length > 0) ? list[0][valueKey] || list[0][labelKey] : ''}
                >
                {
                    list && list.length > 0 ? list.map((field, index) => (
                        <option key={index} value={field[valueKey] || field[labelKey]}>
                            {field[labelKey]}
                        </option>
                    )) : null
                }
            </select>
            <div><DynamicIcon iconClass="fa-solid fa-chevron-down" size="xs" /></div>
        </div>

    )
}